import { getCurrentLanguage } from "utils/src/getCurrentLanguage";
import { apiClient } from "../../../../apps/crossword-maker/src/shared/apiClient";
import {
	ICrosswordBookWordEntity,
	IUpdateCrosswordBookWordDto,
} from "./CrosswordBook.api.types";

export type TUpdateWord = (
	id: string,
	data: IUpdateCrosswordBookWordDto,
) => Promise<ICrosswordBookWordEntity>;

export const updateWord: TUpdateWord = async (id, data) => {
	const language = getCurrentLanguage();
	const response = await apiClient().put<ICrosswordBookWordEntity>(
		`/rest/${language}/crossword-book/word/${id}`,
		data
	);
	return response.data;
};
